export async function getRequestType() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL_P}requestTypeFilter`)
  if (!response.ok) throw new Response('Failed to fetch links', { status: 500 })
  return response.json()
}
export async function getIdeaList(mobile) {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL_P}ideaList?mobile=${mobile}`)
  if (!response.ok) throw new Response('Failed to fetch links', { status: 500 })
  return response.json()
}
export async function getPassageList(mobile) {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL_P}passageList?mobile=${mobile}`)
  if (!response.ok) throw new Response('Failed to fetch links', { status: 500 })
  return response.json()
}
export async function getPassageEdit(id) {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL_P}passageEdit?id=${id}`)
  if (!response.ok) throw new Response('Failed to fetch links', { status: 500 })
  return response.json()
}
export async function passageUpdate(data, id) {
  var requestOptions = {
    method: 'POST',
    body: JSON.stringify(data),
    redirect: 'follow',
  }

  const response = await fetch(`${process.env.REACT_APP_BASE_URL_P}passageUpdate/${id}`, requestOptions)
  if (!response.ok) {
    throw new Response('Failed to provinces', { status: 500 })
  }
  return response.json()
}

export async function getIdeaEdit(id) {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL_P}ideaEdit?id=${id}`)
  if (!response.ok) throw new Response('Failed to fetch links', { status: 500 })
  return response.json()
}
export async function ideaUpdate(data, id) {
  var requestOptions = {
    method: 'POST',
    body: JSON.stringify(data),
    redirect: 'follow',
  }

  const response = await fetch(`${process.env.REACT_APP_BASE_URL_P}ideaUpdate/${id}`, requestOptions)
  if (!response.ok) {
    throw new Response('Failed to provinces', { status: 500 })
  }
  return response.json()
}

export async function getPrintData() {
  let response = await fetch(`${process.env.REACT_APP_BASE_URL_P}printData`)
  if (!response.ok) throw new Response('Failed to fetch links', { status: 500 })
  return response.json()
}
export async function setRequest(data) {
  var formdata = new FormData()
  formdata.append('request_type_id', data.request_type_id)
  formdata.append('fullname', data.fullname)
  formdata.append('address', data.address)
  formdata.append('address_location', data.address_location)
  formdata.append('tel', data.tel)
  formdata.append('title', data.title)
  formdata.append('name', data.name)
  formdata.append('suggestion_names', data.suggestion_names)
  formdata.append('layer', data.layer)

  var requestOptions = {
    method: 'POST',
    body: formdata,
    redirect: 'follow',
  }

  const response = await fetch(`${process.env.REACT_APP_BASE_URL_P}requestSend`, requestOptions)
  if (!response.ok) {
    throw new Response('Failed to provinces', { status: 500 })
  }
  return response.json()
}

export async function getRequestDetail(id) {
  var requestOptions = {
    method: 'GET',
    redirect: 'follow',
  }

  const response = await fetch(`${process.env.REACT_APP_BASE_URL_P}requestDetail/${id}`, requestOptions)
  if (!response.ok) throw new Response('Failed to ', { status: 500 })
  return response.json()
}

export async function deletePassage(id) {
    var myHeaders = new Headers()
  
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow',
    }
    const response = await fetch(`${process.env.REACT_APP_BASE_URL_P}deletePassage/${id}`, requestOptions)
    if (!response.ok) {
      throw new Response('Failed to ', { status: 500 })
    }
    return response.json()
  }

  export async function deleteIdea(id) {
    var myHeaders = new Headers()
  
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow',
    }
    const response = await fetch(`${process.env.REACT_APP_BASE_URL_P}deleteIdea/${id}`, requestOptions)
    if (!response.ok) {
      throw new Response('Failed to ', { status: 500 })
    }
    return response.json()
  }

export async function uploadRequestDoc(fileInput, id, field) {
  var formdata = new FormData()
  formdata.append(field, fileInput)

  var requestOptions = {
    method: 'POST',
    body: formdata,
    redirect: 'follow',
  }

  const response = await fetch(`${process.env.REACT_APP_BASE_URL_P}uploadRequestDoc/${id}/${field}`, requestOptions)
  if (!response.ok) {
    throw new Response('Failed to provinces', { status: 500 })
  }
  return response.json()
}

export async function uploadRequestDocIdea(fileInput, id, field) {
  var formdata = new FormData()
  formdata.append(field, fileInput)

  var requestOptions = {
    method: 'POST',
    body: formdata,
    redirect: 'follow',
  }

  const response = await fetch(`${process.env.REACT_APP_BASE_URL_P}uploadRequestDocIdea/${id}/${field}`, requestOptions)
  if (!response.ok) {
    throw new Response('Failed to provinces', { status: 500 })
  }
  return response.json()
}
